import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  HostListener,
  Input
} from '@angular/core';
import { locale } from './charts-layout-menu.locale';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  ILayout,
  ILayoutEntity
} from 'app/charts-dashboard/interfaces/layout.interface';

@Component({
  selector: 'iv-live-charts-layout-menu',
  templateUrl: './charts-layout-menu.component.html',
  styleUrls: ['./charts-layout-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => ChartsLayoutMenuComponent),
    multi: true
  }]
})
export class ChartsLayoutMenuComponent {

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private elementRef: ElementRef
  ) { }

  public isLayoutMenuOpened: boolean;
  public selectedLayout: ILayoutEntity;
  public locale = locale;

  @Input()
  public layoutsList: ILayout[];

  private _disabled = false;
  public get disabled(): boolean {
    return this._disabled;
  }

  public set disabled(value: boolean) {
    this._disabled = value;
  }

  public openLayoutMenu(): void {
    if (this.isLayoutMenuOpened) {
      this.closeLayoutMenu();
      return;
    }

    this.isLayoutMenuOpened = true;
  }

  public closeLayoutMenu(): void {
    this.isLayoutMenuOpened = false;
  }

  public selectLayout(layout: ILayoutEntity): void {
    this.selectedLayout = layout;
    this.onChange(layout);
    this.onTouched();
    this.closeLayoutMenu();
  }

  @HostListener('document:click', ['$event'])
  private clickOutsideDropdown(event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.closeLayoutMenu();
    }
  }

  // ----------- Методы ControlValueAccessor -----------
  // Вызовет форма, если значение изменилось извне
  public writeValue(outsideValue: ILayoutEntity): void {
    this.selectedLayout = outsideValue;
    this.changeDetectorRef.detectChanges();
  }

  // Сохраняем обратный вызов для изменений
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  // Сохраняем обратный вызов для "касаний"
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // Вызовем когда значение изменится
  private onChange(_: any): void {
  }

  // Вызовем при любом действии пользователя с контроллом
  private onTouched(): void {
  }

  // Установка состояния disabled
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
